import { Helmet } from "react-helmet-async";
import { getSiteOrigin } from "@/lib/siteUrl";

type SeoHeadProps = {
  title: string;
  description: string;
  canonicalPath: string;
  imageUrl?: string;
  type?: "website" | "article";
};

function marketingSiteUrl(): string {
  const origin = getSiteOrigin();
  if (origin) return origin;
  return "https://www.kryajet.com";
}

export function SeoHead({ title, description, canonicalPath, imageUrl, type = "website" }: SeoHeadProps) {
  const siteUrl = marketingSiteUrl();
  const canonicalUrl = `${siteUrl}${canonicalPath.startsWith("/") ? canonicalPath : `/${canonicalPath}`}`;
  const ogImage = imageUrl || `${siteUrl}/og-image.jpg`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
